<template>
  <div>
    <p>GENERAL TERMS & CONIDITIONS</p>
    <p>WARRANTIES, DEFECTS, DELIVERY<br/>
    The Seller warrants that all goods delivered shall be new and conform to requirements, specifications, drawings, quality or any other
descriptions outlined in the RFQ and the Order, prove to be of sound materials and workmanship, capable of any standard of performance
specified in the Order and be without defects and fit for its intended purposes for which the Order is placed.
The Seller warrants that the Goods/Works shall be carried out by suitably competent personnel and equipment supplied shall be in safe
operation condition. Seller shall replace as soon as practicable any such equipment or personnel at Seller's Cost and Risk in case they are not
adequate to the Buyer. The Seller warrants that the Goods/Works will at no time infringe any Intellectual Property Rights or any other right
    </p>
    <p>TERMS OF PAYMENT</p>
    <p style="margin:0">
      Unless otherwise stated in the Order, payment shall be made within Ninety (90) days from the date of receipt of the invoice provided that
      the Buyer receives a correct and valid invoice and provided that the work is correctly delivered or properly performed and the Buyer accepted the
      Goods/Works. If the Goods/Works is not correctly delivered or performed or the Buyer has not accepted the Goods/Work, the invoice shall be
      paid after thirty (30) days following the date when the discrepancy is corrected to the Buyer's satisfaction.
    </p>
    <p style="margin:0;">
      Payment invoices should be shown to the Accounts Office and not to any individual person. Unless it has been specified in the contract. Prices
      quoted by Seller and accepted by Buyer are final. No changes can be accepted unless agreed in writing by both parties. Seller shall sustain all
      Taxes, import fees, freight to destination and the like related to the performance of Goods/Works. These items must be
      shown separately in the invoice.
    </p>
    <p style="margin:0">
      Failure to meet the delivery as agreed upon shall be considered a breach of these Conditions and the Seller shall be responsible to pay penalty
      and damages imposed upon or incurred by the Buyer (if any) for failure of Seller to deliver Goods/Works according to the Order. Furthermore,
      the Seller shall bear the cost of packing, loading and carriage of the Goods/Works unless otherwise agreed upon between both parties hereto
      (Buyer and Seller). If the Goods/Works is delivered to the Buyer in excess of the quantities ordered, the Buyer shall not be bound to pay for the
      excess and any excess will be and will remain at the Seller's risk and will be returnable at the Seller's expense. Buyer will not take in any
      responsibility for loss of Goods, without any delivery note shown. Buyer have the right to reject any of the Seller's Assigned Personnel, if the
      personnel or personnel's behavior is not acceptable as per Owner Standards.
    </p>
    <p>
      INSPECTION & TESTING<br/>
      Seller agrees to permit the Buyer to inspect and test the Goods/Works any time prior to acceptance or delivery as the case may be. Buyer shall
      have the rights without prejudice to any other right which the Buyer may have against the Seller to reject any Goods/Works performed or
      delivered by the Seller if such Goods/Services is defective or in non-compliance with the Terms and Conditions herein. Any Goods/Works so
      rejected shall immediately be replaced or corrected as required by Buyer at Seller's expense. Seller shall re-submit the re-performed
      Goods/Works for reinsertion and re-testing. Such replacement or remedy shall not relieve the Seller from any liability due to defects
      subsequently found in the Goods/Works in terms of materials and/ or workmanship. A notice not less than five (5) calendar days shall be given
      to Buyer in order to inspect and test the Goods/Works.
    </p>
  </div>
</template>

<script>

export default {
  name: "LPOTerms",
  data() {
    return {
    };
  },
};
</script>
